import React from 'react';
import { Minus, X, RefreshCw } from 'react-feather';
import { useChatbot } from './ChatbotContext';

/**
 * Header da janela de chat com botoes de acao
 */
const ChatbotHeader = () => {
  const { minimizeChat, closeChat, startNewConversation, messages } = useChatbot();

  return (
    <div className="chatbot-header">
      <div className="chatbot-header-info">
        <div className="chatbot-avatar">P</div>
        <div className="chatbot-header-text">
          <span className="chatbot-header-title">Phada Copiloto</span>
          <span className="chatbot-header-status">
            <span className="chatbot-status-dot" />
            Online
          </span>
        </div>
      </div>
      <div className="chatbot-header-actions">
        {messages.length > 0 && (
          <button
            type="button"
            className="chatbot-header-btn"
            onClick={startNewConversation}
            title="Nova conversa"
            aria-label="Iniciar nova conversa"
          >
            <RefreshCw size={14} />
          </button>
        )}
        <button
          type="button"
          className="chatbot-header-btn"
          onClick={minimizeChat}
          title="Minimizar"
          aria-label="Minimizar chat"
        >
          <Minus size={14} />
        </button>
        <button
          type="button"
          className="chatbot-header-btn"
          onClick={closeChat}
          title="Fechar"
          aria-label="Fechar chat"
        >
          <X size={14} />
        </button>
      </div>
    </div>
  );
};

export default ChatbotHeader;
